// extracted by mini-css-extract-plugin
export var aircallIframe = "_jh-3";
export var fabContainer = "_jh-5";
export var fabRinging = "_jh-6";
export var loadingOverlay = "_jh-4";
export var pulse = "_jh-7";
export var widgetContent = "_jh-2";
export var widgetPanel = "_jh-0";
export var widgetPanelExpanded = "_jh-1";